import Reading from '@assets/icons/reading.svg'
import { Icon } from './Icon'

export const ReadingIcon = Icon(Reading)
